module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-300.4f691391.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-300.woff
// module id = 477
// module chunks = 0